import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c6948e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container max-w-2xl mx-auto" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-5 mx-auto message" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "pb-2" }, "You have been discharged from the current COPD Virtual Ward."),
  /*#__PURE__*/_createElementVNode("p", { class: "py-2" }, "If you are feeling unwell, you should contact your GP or the Emergency Department."),
  /*#__PURE__*/_createElementVNode("p", { class: "pt-2" }, [
    /*#__PURE__*/_createElementVNode("b", { class: "font-semibold" }, " For all emergencies call 999 ")
  ])
], -1))
const _hoisted_4 = { class: "px-2 py-4" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Log Out")
const _hoisted_6 = { class: "bg-gray-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_BaseCard = _resolveComponent("BaseCard")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: "" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_ion_grid, { id: "discharged-page" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_row, { class: "text-xl font-semibold text-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, {
                      size: "12",
                      class: "mb-2 ion-no-padding"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          id: "userlogin",
                          src: _ctx.userFull,
                          class: "w-12 h-12 mx-auto mb-2",
                          alt: "",
                          role: "presentation"
                        }, null, 8, _hoisted_2)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_col, {
                      size: "12",
                      class: "ion-no-padding"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("h1", null, _toDisplayString(_ctx.pageTitle), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_BaseCard, { class: "flex items-center h-auto m-4 mt-6" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_grid, { class: "flex flex-col ion-no-padding" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, { size: "12" }, {
                          default: _withCtx(() => [
                            _hoisted_3
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_ion_button, {
                id: "logout-button",
                expand: "block",
                fill: "outline",
                onClick: _withModifiers(_ctx.logout, ["prevent"])
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_ion_icon, {
              id: "bp-logo",
              src: _ctx.bigPicture
            }, null, 8, ["src"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}